import React from 'react'
import { ControlledSelectField } from '../ControlledSelectField'

export const CampaignTypeSelect = () => {
  const typeMenuItems = [
    { value: 'Customised Campaign', label: 'Customised Campaign' },
    { value: 'Product Seeding', label: 'Product Seeding' },
    { value: 'Affiliate Marketing', label: 'Affiliate Marketing' }
  ]

  return (
    <ControlledSelectField
      name='campaign.type'
      label='Type of Campaign'
      menuItems={typeMenuItems}
    />
  )
}
